.folderRow {
  cursor: pointer;
}

.folderRow:hover {
  background-color: #f5f5f5;
}

.draggableRow {
  cursor: grab;
}

.draggableRow:active {
  cursor: grabbing;
}

.dragging {
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.dropTarget {
  background-color: var(--mantine-color-brand-3) !important;
  border: 2px dashed var(--mantine-color-brand-6);
}

.dropTargetInvalid {
  background-color: var(--mantine-color-error-3) !important;
  border: 2px dashed var(--mantine-color-error-6);
  cursor: not-allowed;
}
